<template>
    <div
        v-if="options.length > 1"
        class="mt-4 mb-6"
    >
        <p class="text-sm font-oceanside">
            {{groupByLabel}}
        </p>

        <base-input-select
            :select-options="options"
            @input="selectOption"
        />
    </div>
</template>

<script>
    import BaseInputSelect from '../BaseInputSelect.vue';

    export default {
        components: {
            BaseInputSelect,
        },

        emits: ['selected'],

        props: {
            groupByLabel: String,
            option: Object,
            selectedValue: String,
        },

        computed: {
            options() {
                return this.option.grouped.map((o) => ({
                    label: o.group,
                    code: o.value,
                    selected: o.selected,
                }));
            },
        },

        methods: {
            selectOption(o) {
                this.$emit('selected', o.code);
            },
        },
    };
</script>
